import { useCallback, useEffect, useState } from 'react';
import { ContractService } from '../../../services/contract/contractService';
import { usePrivilege } from '../../../components/priviledge/PriviledgeProvider';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage contract commercial fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de comerciales de contratos.
----------------------------------------------------------------------------------------*/

const useContractCommercial = (initialFilters = {}) => {

    const { userCan } = usePrivilege();

    const [data, setData] = useState<any[]>([]);
    const [filters, setFilters] = useState({
        limit: 999999,
        filter_filters: { ...initialFilters }
    });
    
    const canLoadCommercials = userCan(
    'admin_all_commercial_network_contracts',
    'commercial_network'
  );

    const fetchContractCommercial = useCallback(async (f?: any) => {
        try {
            const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
            const service = new ContractService();
            const response = await service.findCommercialsOnContract(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; name: string; lastName: string; email: string; }) => {
                    const name = data.name + (data.lastName ? ' ' + data.lastName : '');
                    return ({
                        value: data.id,
                        label: `${name} (${data.email})`,
                    })
                });
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching contracts commercials:', error);
        }
    }, []);

    useEffect(() => {
        if(canLoadCommercials) {
            fetchContractCommercial();
        }
        else {
            setData([]);
        }
    }, [filters]);

    const updateContractCommercialHookFilters = (newFilters: any) => {
        setFilters((prevFilters) => ({ ...prevFilters, ...newFilters }));
    };

    const getContractCommercialList = () => {
        return data;
    };

    return { fetchContractCommercial, getContractCommercialList, updateContractCommercialHookFilters };
}

export default useContractCommercial;